/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-useless-escape */

// パスワードのバリデーションを行う
export const validateRequiredField = (target: string): boolean => target === "";
